<template>
  <div class="section-collect-card" ref="root">
    <div
      class="activity-task-float-btn"
      v-open-app
      @click="$emit('showTaskModal')"
    ></div>
    <div class="section-title"></div>
    <div class="collect-card-wrapper">
      <div class="open-card-area">
        <div class="open-card-count">
          <span>剩余福卡: {{ cd.left_box_cnt }}</span>
          <div class="btn-to-collect" @click="$emit('showTaskModal')">
            去集卡
            <HbIcon common-arrow-right-line />
          </div>
        </div>
        <div class="open-card-container">
          <div
            class="waiting-card"
            :class="{ flipped: flipPos.flipped }"
            v-for="(flipPos, index) in filpPool"
            :key="index"
            @click="handleOpenCard(flipPos)"
          >
            <div class="card-back">
              <img
                class="content-img"
                v-src="
                  'https://imgheybox.max-c.com/oa/2025/01/20/1f40a8223e4cff3d9c73bc1de42895ee.png'
                "
              />
            </div>
            <div class="card-front" v-show="flipPos.flipped">
              <img
                class="content-img"
                v-src="flipPos.big_card_showing_url || ''"
              />
              <img class="decorator-img" v-src="flipPos.big_card_url || ''" />
            </div>
          </div>
        </div>
      </div>
      <div class="divi-line"></div>
      <div class="share-card-area">
        <div class="collect-card-count">每集齐5张卡 获得祈福机会</div>
        <div class="share-card-container">
          <div
            class="card-collection-item"
            v-for="card in cardList"
            :key="card.card_id"
            :id="`card-${card.card_id}`"
          >
            <div class="card-img-wrapper">
              <img
                v-if="card.count > 0"
                class="collected"
                v-src="card.small_card_url"
              />
              <img
                v-else
                class="uncollected"
                v-src="card.small_card_cover_url"
                alt=""
              />
              <div class="card-count" v-if="card.count > 0">
                <div class="count-value">{{ card.count }}</div>
              </div>
            </div>
            <div
              class="gift-btn"
              v-if="cd.enable_gift"
              :style="card.count > 0 ? highlightBtnStyle : uncollectBtnStyle"
              @click="handleSelectReceiver(card.card_id)"
            >
              赠送
            </div>
          </div>
        </div>
      </div>
      <div class="btn-wrapper">
        <div class="btn-normal award-history" @click="showRecord">中奖记录</div>
        <div
          class="combine-btn"
          :class="{ disabled: !canCombine }"
          @click="handleCombineCard"
        >
          <div class="open-count-tag" v-if="canCombine && gd.score_left > 0">
            <div class="open-count-value">
              {{ Math.floor(gd.score_left / 10) }}
            </div>
          </div>
        </div>
        <div class="btn-normal award-list" @click="showAwardPool">奖池大赏</div>
      </div>
    </div>

    <!-- 用户列表弹窗 -->
    <FadeModal class="search-user-modal" ref="search-modal" :gc="gc">
      <div class="search-input-wrapper">
        <img
          class="search-icon"
          v-src="
            'https://imgheybox.max-c.com/oa/2025/01/20/64056c8421b8ba8a6008caaed5872d68.png'
          "
        />
        <input
          v-model="searchInput"
          ref="search-input"
          @input="searchUser(true)"
          type="text"
          placeholder="搜索黑盒用户ID"
        />
      </div>
      <div class="user-list-container">
        <HbList
          :loading="listLoadingUser"
          :finished="!hasMoreUser"
          finishedText=""
          @load="searchUser"
          v-if="curUserList.length"
        >
          <div class="user-line" v-for="user in curUserList" :key="user.userid">
            <img class="user-avatar" v-src="user.avatar" />
            <div class="user-info">
              <div class="user-name">{{ user.username }}</div>
            </div>
            <div class="user-btn" @click="handleConfirmReceiver(user)">
              赠送
            </div>
          </div>
        </HbList>
        <HbEmpty color="#FFA742" v-else />
      </div>
    </FadeModal>
    <!-- 赠送卡牌确认 -->
    <Modal
      ref="gift-modal"
      class="gift-modal-wrapper"
      :showCloseBtn="false"
      border_color="#FFC470"
    >
      <div class="gift-modal">
        <div class="gift-title">赠送给: {{ curSendingUser.username }}</div>
        <img
          class="gift-card-img"
          v-if="curSendingCard"
          v-src="curSendingCard.small_card_url"
        />
        <div class="gift-tips">
          您今天还可以赠送 {{ sendGiftRemainCount }} 张卡
        </div>
        <div class="gift-btn-wrapper">
          <div class="cancel-btn" @click="cancelSendCard">取消</div>
          <div
            class="gift-btn"
            :style="sendGiftRemainCount ? highlightBtnStyle : uncollectBtnStyle"
            @click="confirmSendCard"
          >
            赠送
          </div>
        </div>
      </div>
    </Modal>
    <!-- 翻牌动画 -->
    <Modal
      class="lottery-card-modal"
      ref="lottery-modal"
      :over_close="false"
      :showCloseBtn="false"
      border_color="transparent"
    >
      <div class="lottery-card-modal-content">
        <transition name="card-fade">
          <div class="lottery-card" v-if="showCard" ref="card">
            <img
              class="card-back"
              v-src="
                'https://imgheybox.max-c.com/oa/2025/01/20/1f40a8223e4cff3d9c73bc1de42895ee.png'
              "
            />
            <img class="card-face" v-src="curShowingCardImg" />
          </div>
        </transition>
      </div>
    </Modal>
    <!-- 合成卡片lottie -->
    <Modal
      class="combine-card-modal"
      ref="combine-card-modal"
      :over_close="false"
      :showCloseBtn="false"
      border_color="transparent"
    >
      <CptLottie
        class="lottie-combine-card"
        :options="lottieOption"
        :width="lottieOption.width"
        :height="lottieOption.height"
        @animeCreated="handleAnimeCreated"
      ></CptLottie>
    </Modal>
    <!-- 厂商祝福 -->
    <Modal
      class="wish-prize-modal"
      ref="wish-card-modal"
      border_color="transparent"
      :over_close="false"
    >
      <div class="wish-card-wrapper" @click="toWishLink">
        <div class="wish-card__game-img">
          <img v-src="wishCardInfo.game_cover" alt="" />
        </div>
        <div class="wish-card__mask">
          <div class="wish-card__user-info">
            <div class="avatar">
              <img v-src="wishCardInfo.avatar" alt="" />
            </div>
            <div class="username">{{ wishCardInfo.username }}</div>
          </div>
        </div>
      </div>
    </Modal>
    <!-- cdkey中奖弹窗 -->
    <Modal
      class="lottery-prize-modal"
      ref="prize-modal"
      title="恭喜中奖"
      border_color="#FFC470"
    >
      <div class="prize-modal-wrapper">
        <div class="prize-lottery-item" :class="'color-' + award.rarity">
          <div class="prize-name">
            <p>{{ award.name }}</p>
          </div>
          <div class="image-box">
            <img v-src="award.img_url" alt="" />
            <div :class="'image-cover color-' + award.rarity"></div>
          </div>
          <p class="tag">
            {{ ['隐秘', '传说', '史诗', '稀有', '普通'][award.rarity - 1] }}
          </p>
        </div>
        <p class="distribute-desc">
          {{ notify_content }}
        </p>
        <div class="btn-done" @click="closePrizeModal">确认</div>
      </div>
    </Modal>
    <!-- 中奖记录 -->
    <Modal
      ref="lottery-records"
      class="lottery-records-modal"
      width="315px"
      title="中奖记录"
      border_color="#FFC470"
    >
      <div class="message-content">
        <div class="records">
          <div
            class="record-item"
            v-for="item in lotteryRecords"
            :key="item.timestamp"
          >
            <p class="text-2">获得</p>
            <div class="prize-name">
              <div class="inner" :class="'color-' + item.rarity">
                <p class="tag" :style="{ color: '#FFFFFF' }">
                  {{
                    ['隐秘', '传说', '史诗', '稀有', '祝福'][item.rarity - 1]
                  }}
                </p>
                <p class="text-4">
                  {{ item.rarity == 5 ? '厂商祝福' : item.name }}
                </p>
              </div>
            </div>
            <p class="text-1">
              {{ item.timestamp | formatTimestamp }}
            </p>
          </div>
          <HbEmpty
            color="#DE022C"
            v-if="lotteryRecords.length == 0"
            desc="暂无中奖记录"
          ></HbEmpty>
        </div>
      </div>
      <div class="message-footer" v-if="lotteryRecords.length">
        <p>游戏奖品已放入“我-黑盒商城-我的钱包”中，请及时兑换哦</p>
      </div>
    </Modal>
    <!-- 奖池大赏 -->
    <FadeModal
      class="lottery-prize-pool-modal"
      ref="lottery-prize-pool"
      title="祈福奖池"
      title_color="#DA143A"
      :radius="'12px'"
    >
      <div class="prize-list-cate-wrapper colors">
        <div
          class="prize-list-cate-item"
          :class="'color-' + item.rarity"
          v-for="item in awardPoolList"
          :key="item.text"
          v-show="item.list.length > 0"
        >
          <span class="tag">{{ item.text }}奖品 {{ item.probability }}</span>
          <div class="prize-list">
            <div
              class="prize-item"
              v-for="prize in item.list"
              :key="prize.award_id"
            >
              <div class="prize-card">
                <div class="prize-cover"></div>
                <div class="prize-image">
                  <img
                    v-src="
                      prize.rarity === 5
                        ? 'https://imgheybox.max-c.com/oa/2025/01/22/6dc5f0496af1f77745145343608b35e3.png'
                        : prize.img
                    "
                    alt=""
                  />
                </div>
                <div class="prize-price">
                  <div class="left">
                    <span class="text1">价值</span>
                    <span class="char" v-if="prize.price">¥</span>
                    <span class="large">{{ prize.price || '-' }}</span>
                  </div>
                  <template v-if="prize.show_type != 2">
                    <div class="split-line">
                      <div class="inner"></div>
                    </div>
                    <div class="right">
                      <div class="inner-text">
                        {{
                          prize.show_type == 0
                            ? '剩 ' + prize.remain_point
                            : '无限量'
                        }}
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <p class="prize-name">
                {{ prize.rarity == 5 ? '厂商祝福' : prize.name }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </FadeModal>
  </div>
</template>

<script>
import {
  showMessage,
  sendClientRequest,
  geVersion,
  getOSType,
  getParams,
  executeProtocol,
  redirectUrlByServer,
} from '_lib/utils';
import { debounce } from 'lodash';

import FadeModal from '../components/fade-modal.vue';
import Modal from '../components/modal.vue';
import CptLottie from '../components/cpt-lottie.vue';

import {
  getFollowingUsers,
  searchUser,
  openSelectCard,
} from '_api/activity-common-template';
import { getDrawLog } from '_api/activity-common-template.js';

export default {
  name: 'section-collect-card',
  components: {
    FadeModal,
    Modal,
    CptLottie,
  },
  props: {
    act_id: {
      type: String,
      default: '',
    },
    cc: {
      // component_conf
      type: Object,
      default: () => {},
    },
    cd: {
      // component_data
      type: Object,
      default: () => {},
    },
    gc: {
      // common_config
      type: Object,
      default: () => {},
    },
    gd: {
      // game_data
      type: Object,
      default: () => {},
    },
    awardPoolList: {
      type: Array,
      default: () => [],
    },
    devUserList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isInHeybox: this.$hb_env.is_inapp,
      searchInput: '',
      querys: getParams(),

      //用户列表加载
      followList: [],
      searchList: [],
      hasMoreUser: true,
      listLoadingUser: false,
      userOffset: 0,
      userLimit: 30,

      //抽签
      showCard: false,
      lotteryLock: false,
      combineLock: false,
      sendLock: false,
      curShowingCardImg: '',

      curSendingCardId: '',
      curSendingUser: {},

      //送礼
      giftMap: {},

      lotteryRecords: [],
      award: {},
      notify_content: '',
      lottieOption: {
        name: 'combine_card',
        loop: false,
        autoplay: false,
        animationData: require('../lottie/lottie_combine_card.json'),
        width: Math.min(window.innerWidth, 480),
        height: (Math.min(window.innerWidth, 480) * 812) / 375,
      },
      anime_combine_card: null,
      showCombineAnime: false,
      wishCardInfo: {
        game_cover: '',
        link_id: '',
        avatar: '',
        username: '',
      },
    };
  },
  computed: {
    cardList() {
      return this.cd.card_list || [];
    },
    filpPool() {
      if (!this.cd.flip_records) return [];
      let posList = ['left', 'mid', 'right'].map((pos) => {
        let flipRecord = this.cd?.flip_records[pos];
        if (flipRecord.flipped) {
          // 已开
          let cardRecord = this.cardList.find(
            (card) => card.card_id == flipRecord.card_id,
          );
          return {
            ...flipRecord,
            ...cardRecord,
            pos,
          };
        } else {
          // 未开
          return {
            ...flipRecord,
            pos,
          };
        }
      });
      return posList;
    },
    canCombine() {
      return (
        (this.cardList.reduce((acc, cur) => {
          return acc && cur.count > 0;
        }, true) &&
          this.cd.left_combine_cnt > 0) ||
        this.gd.score_left > 0
      );
    },
    sendGiftRemainCount() {
      return this.cd.send_limit - (this.cd.send_count || 0);
    },
    highlightBtnStyle() {
      return {
        background:
          'linear-gradient(90deg, #FF8F57 0%, #FF4A49 25%, #FF263E 75%, #FF7191 100%)',
        color: '#FFEDDC',
      };
    },
    uncollectBtnStyle() {
      return {
        background: '#FFEAD7',
        color: '#D5B690',
      };
    },
    cancelBtnStyle() {
      return {
        background: this.convertLinearGradient(this.cc.disabled_btn_bg),
        color: this.cc.disabled_btn_color,
      };
    },
    collectionToCombine() {
      const result = [];
      for (let i = 0; i < this.cardList.length; i += 3) {
        result.push(this.cardList.slice(i, i + 3));
      }
      return result;
    },
    curUserList() {
      return this.searchInput ? this.searchList : this.followList;
    },
    curSendingCard() {
      return this.cardList.find(
        (item) => item.card_id === this.curSendingCardId,
      );
    },
  },
  mounted() {
    this.isInHeybox && this.getFollowingUsers();
  },
  methods: {
    handleAnimeCreated(anim) {
      this.anime_combine_card = anim;
    },
    //开卡
    async handleOpenCard(pos) {
      // if (!this.isInHeybox) {
      //   this.openInHeybox();
      //   return;
      // }
      if (this.lotteryLock || pos.flipped) return;
      this.lotteryLock = true;
      this.$toast.loading({
        duration: false,
      });
      let { data } = await openSelectCard({
        heybox_id: this.querys.heybox_id,
        act_id: this.act_id,
        position: pos.pos,
        _notip: true,
      });
      if (data.status === 'ok') {
        let { card_id } = data.result;
        this.showLotteryResult(card_id);
        //剩余抽卡机会减少
        this.$set(this.cd, 'left_box_cnt', this.cd.left_box_cnt - 1);

        let cardRecord = this.cd.card_list.find(
          (item) => item.card_id === card_id,
        );
        // 已抽卡次数增加
        cardRecord.count += 1;
        if (this.cd.flip_records[pos.pos]) {
          // eslint-disable-next-line
          this.cd.flip_records[pos.pos].card_id = card_id;
          // eslint-disable-next-line
          this.cd.flip_records[pos.pos].flipped = true;
        }
        setTimeout(() => {
          // this.$parent.reload();
          this.$emit('refreshData');
        }, 1500);
      } else {
        showMessage(data.status, data.msg);
      }
      this.$toast.close();
      this.lotteryLock = false;
    },
    calcShrinkScale(card_id) {
      // 计算动画缩为小卡时参数
      let smallCard = document.getElementById(`card-${card_id}`);
      if (smallCard) {
        let smallCardPos = smallCard.getBoundingClientRect();

        //缩小比例
        let smallCardWidth = smallCardPos.width.toFixed(0);
        let shrinkScale = (smallCardWidth / 160).toFixed(1);
        this.$refs['root'].style.setProperty('--target-scale', shrinkScale);

        //缩小位置
        let relativeX =
          smallCardPos.left + smallCardPos.width / 2 - window.innerWidth / 2;
        let relativeY =
          smallCardPos.top + smallCardPos.height / 2 - window.innerHeight / 2;
        this.$refs['root'].style.setProperty('--target-x', `${relativeX}px`);
        this.$refs['root'].style.setProperty('--target-y', `${relativeY}px`);
      } else {
        this.$refs['root'].style.setProperty('--target-scale', '0.4');
        this.$refs['root'].style.setProperty('--target-x', '0px');
        this.$refs['root'].style.setProperty('--target-y', '300px');
      }
    },
    showLotteryResult(card_id) {
      this.curShowingCardImg = this.cardList.find(
        (card) => card.card_id === card_id,
      )?.big_card_showing_url;
      this.$refs['lottery-modal'].showModal();
      this.calcShrinkScale(card_id);
      this.$nextTick(() => {
        this.showCard = true;
        setTimeout(() => {
          this.showCard = false;
          setTimeout(() => {
            this.$refs['lottery-modal'].hideModal(true);
          }, 550);
        }, 1000);
      });
    },

    //打开选择用户列表
    async getFollowingUsers() {
      let { data } = await getFollowingUsers({});
      if (data.status == 'ok') {
        this.followList = data.follow_list || [];
      }
    },
    handleSelectReceiver(card_id) {
      if (this.sendGiftRemainCount <= 0) {
        showMessage('failed', '今日赠送次数已用完');
        return;
      }
      if (!this.cd.enable_gift) return;
      let curCard = this.cardList.find((card) => card.card_id === card_id);
      if (curCard.count < 1) {
        showMessage('failed', '没有多余卡牌');
        return;
      }
      this.curSendingCardId = card_id;
      this.$refs['search-modal'].showModal();
    },
    searchUser: debounce(async function (isInit) {
      if (!this.searchInput || this.listLoadingUser) {
        return;
      }
      if (isInit) {
        this.hasMoreUser = true;
      }
      this.listLoadingUser = true;
      let { data } = await searchUser({
        q: this.searchInput,
        limit: this.userLimit,
        offset: isInit ? 0 : this.userOffset,
        search_type: 'user',
      });
      if (data.status == 'ok') {
        let newList =
          data.result.items
            .filter((item) => item.type == 'user')
            .map((item) => item.info) || [];
        if (newList.length < this.userLimit) {
          this.hasMoreUser = false;
        }
        if (isInit) {
          this.searchList = newList;
        } else {
          this.searchList = this.searchList.concat(newList);
        }
        this.userOffset = this.searchList.length;
      }
      this.listLoadingUser = false;
    }, 200),
    //选好用户
    handleConfirmReceiver(user) {
      this.curSendingUser = user;
      this.$refs['gift-modal'].showModal();
    },
    // 赠送指定用户卡牌
    async confirmSendCard() {
      if (this.sendLock || !this.curSendingCard.count) return;
      if (!this.sendGiftRemainCount) {
        showMessage('failed', '今日赠送次数已用完');
        return;
      }
      this.sendLock = true;
      sendClientRequest({
        url: '/game/h5_activity/repeatable_card_collect/send_card',
        type: 'POST',
        query: {
          heybox_id: this.querys.heybox_id,
        },
        data: {
          act_id: this.act_id,
          card_id: this.curSendingCardId,
          receiver_heybox_id: this.curSendingUser.userid,
        },
        need_encrypt: 1,
        protocol_options: {
          add_client_pkey: 1,
          needCookie: true,
        },
      })
        .then((data) => {
          if (data.status == 'ok') {
            showMessage('ok', '赠送成功');
            this.$refs['gift-modal'].hideModal();
            this.curSendingUser = {};

            // eslint-disable-next-line
            this.cd.send_count++;

            let card = this.cd.card_list.find(
              (card) => card.card_id == this.curSendingCardId,
            );
            card.count--;
            if (card.count <= 0) {
              this.$refs['search-modal'].hideModal();
              showMessage('failed', '没有更多卡了');
            }
          } else {
            this.$refs['gift-modal'].hideModal();
            showMessage('failed', data.error);
          }
          this.sendLock = false;
        })
        .catch((err) => {
          this.sendLock = false;
          if (!(getOSType() == 'Android' && !geVersion('1.3.315'))) {
            showMessage('failed', err);
          }
        });
    },
    cancelSendCard() {
      this.$refs['gift-modal'].hideModal();
      this.curSendingUser = {};
    },

    // 集卡
    async handleCombineCard() {
      if (
        (!this.canCombine || this.cd.left_combine_cnt < 1) &&
        this.gd.score_left === 0
      ) {
        this.$emit('showTaskModal');
        return;
      }
      if (this.gd.score_left > 0) {
        this.openBox(true);
        return;
      }
      if (this.combineLock) return;
      this.combineLock = true;
      this.$toast.loading({
        duration: false,
      });
      sendClientRequest({
        url: '/game/h5_activity/repeatable_card_collect/combine_card',
        need_encrypt: 1,
        type: 'GET',
        query: {
          heybox_id: this.querys.heybox_id,
          act_id: this.act_id,
        },
        protocol_options: {
          add_client_pkey: 1,
          needCookie: true,
        },
      })
        .then((data) => {
          this.combineLock = false;
          this.$toast.close();
          if (data.status == 'ok') {
            this.openBox();
            // this.$emit('refreshData');
          } else {
            showMessage(data.status, data.msg);
          }
        })
        .catch((err) => {
          this.combineLock = false;
          this.$toast.close();
          if (!(getOSType() == 'Android' && !geVersion('1.3.315'))) {
            showMessage('failed', err);
          }
        });
    },
    // finishCombineCard() {
    //   this.$refs['combine-card-modal'].hideModal();
    // },

    convertLinearGradient(string) {
      let arr = string.split(',');
      if (arr.length == 1) {
        return arr[0];
      } else {
        return `linear-gradient(45deg, ${arr[0]} 0%, ${arr[1]} 100%)`;
      }
    },

    /*
     * 抽卡
     */
    openBox(skip_combine) {
      sendClientRequest({
        url: '/game/h5_activity/open_box',
        need_encrypt: 1,
        type: 'GET',
        query: {
          heybox_id: this.querys.heybox_id,
          act_id: this.act_id,
          // box_machine_id: this.cc.box_machine_id,
          // task_os_type: this.querys.task_os_type,
          task_os_type: 'web',
          client_version: this.querys.version,
        },
        protocol_options: {
          add_client_pkey: 1,
          needCookie: true,
        },
      })
        .then((content) => {
          if (content.status == 'ok') {
            const data = content.result;

            this.notify_content =
              data.award_list[0].name === '谢谢参与'
                ? '很遗憾，未中奖'
                : data.notify_content || '';
            this.award = data.award_list[0];
            this.score_left = data.award_list[0].left_count;
            // console.log(this.award);
            if (skip_combine) {
              this.$refs['prize-modal'].showModal();
              this.$emit('refreshData');
              return;
            }
            const isWishCard = this.award.unlucky;
            this.$refs['combine-card-modal'].showModal();
            this.$nextTick(() => {
              this.showCombineAnime = true;
              this.anime_combine_card.play();
              if (isWishCard) {
                let user = null;
                if (this.award.name === '谢谢参与') {
                  user = this.devUserList[0];
                } else {
                  const userList = this.devUserList.filter(
                    (item) => Number(item.heybox_id) == Number(this.award.name),
                  );
                  if (userList.length > 1) {
                    user =
                      userList[Math.floor(Math.random() * userList.length)];
                  } else if (userList.length === 1) {
                    user = userList[0];
                  } else {
                    user =
                      this.devUserList[
                        Math.floor(Math.random() * this.devUserList.length)
                      ];
                  }
                }
                this.wishCardInfo.avatar = user.avatar;
                this.wishCardInfo.username = user.username;
                this.wishCardInfo.game_cover = user.game_cover;
                this.wishCardInfo.link_id = user.link_id;

                setTimeout(() => {
                  this.$refs['wish-card-modal'].showModal();
                }, 2000);
              } else {
                setTimeout(() => {
                  this.$refs['prize-modal'].showModal();
                }, 2000);
              }
              let removeListener = this.anime_combine_card.addEventListener(
                'complete',
                () => {
                  // this.anime_combine_card.loop = true;
                  this.showCombineAnime = false;
                  this.anime_combine_card.goToAndStop(0);
                  removeListener();
                  removeListener = null;
                  // this.$toast.close();
                  this.$refs['combine-card-modal'].hideModal(true, true);
                },
              );
            });
            this.$emit('refreshData');
          } else {
            // showMessage('failed', content.msg)
            showMessage(
              'failed',
              skip_combine
                ? '由于当前参与活动人数过多导致祈福失败，请稍后再试'
                : '祈福次数+1，由于当前参与活动人数过多导致祈福失败，请稍后再试',
            );
            this.$emit('refreshData');
          }
          this.lottery_lock = false;
        })
        .catch(() => {
          if (!(getOSType() == 'Android' && !geVersion('1.3.315'))) {
            showMessage(
              'failed',
              skip_combine
                ? '由于当前参与活动人数过多导致祈福失败，请稍后再试'
                : '祈福次数+1，由于当前参与活动人数过多导致祈福失败，请稍后再试',
            );
          }
          this.$emit('refreshData');
          this.lottery_lock = true;
          this.$refs['combine-card-modal'].hideModal(true);
        });
    },
    showRecord() {
      if (this.querys.heybox_id == '-1') {
        executeProtocol({
          protocol_type: 'login',
        });
        return;
      }
      this.getRecordsData();
    },
    getRecordsData() {
      getDrawLog({
        heybox_id: this.querys.heybox_id,
        act_id: this.act_id || this.querys.act_id,

        // box_machine_id: this.cc.box_machine_id,
        task_os_type: 'web',
        client_version: this.querys.version,
      }).then(({ data }) => {
        if (data.status == 'ok') {
          this.lotteryRecords = data.result.award_list || [];

          this.$refs['lottery-records'].showModal();
        }
      });
      // this.showRecord()
    },
    showAwardPool() {
      this.$refs['lottery-prize-pool'].showModal();
    },

    closePrizeModal() {
      this.$refs['prize-modal'].hideModal();
    },
    toWishLink() {
      executeProtocol({
        protocol_type: 'openWindow',
        webview: {
          url: redirectUrlByServer(
            `/v3/bbs/app/api/web/share/?link_id=${this.wishCardInfo.link_id}`,
            'heybox',
          ),
        },
      });
      // this.$refs['wish-card-modal'].hideModal()
    },
  },
  filters: {
    formatTimestamp(timestamp) {
      var now = Math.ceil(new Date().getTime() / 1000);
      var delta = Math.ceil(now - timestamp);

      if (delta < 60) {
        return `${delta}秒前`;
      } else if (delta < 3600) {
        return `${Math.floor(delta / 60)}分钟前`;
      } else if (delta < 3600 * 24) {
        return `${Math.floor(delta / 3600)}小时前`;
      } else {
        return `${Math.floor(delta / (3600 * 24))}天前`;
      }
    },
  },
};
</script>

<style lang="less">
.section-collect-card {
  position: relative;
  margin: -8px 12px 0;
  --target-x: 100px;
  --target-y: 200px;
  --target-scale: 0.4;
  z-index: 9;
  .section-title {
    width: 100%;
    padding-top: calc(37 / 351 * 100%);
    background:
      center / auto 100%
        url(https://imgheybox.max-c.com/oa/2025/01/21/66c291b81fce902e96b5050a4624cbcb.png)
        no-repeat,
      center top 1px ~'/' auto calc(100% - 10px)
        url(https://imgheybox.max-c.com/oa/2025/01/23/c89ef7a31d3033647bb3675e54a7e958.png)
        no-repeat;
  }
  .activity-task-float-btn {
    position: fixed;
    right: 0;
    top: 130px;
    width: 56px;
    height: 56px;
    background: center / 100% 100%
      url(https://imgheybox.max-c.com/oa/2025/01/20/b247420b3b5a1f3ab1c0f6da82046215.png)
      no-repeat;
    z-index: 10;
  }
  .collect-card-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    padding: 12px 12px 15px;
    background: center top / 100% 80px
      linear-gradient(0deg, #ffffff 0%, #ffffe2 100%) no-repeat #ffffff;
    border-radius: 10px;
    margin-top: 6px;
    .cpt-decorator {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
    .open-card-area {
      width: 100%;
      position: relative;
      .open-card-count {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        color: #d0001b;
        font-family: 'PingFang SC';
        font-size: 15px;
        font-weight: 500;
        line-height: 21px;
        padding-left: 1px;
        .btn-to-collect {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          line-height: 17px;
          font-weight: 400;
          padding: 1px 4px 1px 8px;
          background: linear-gradient(263.62deg, #ffd99e 4.77%, #ffebd0 92.7%);
          border-radius: 10px;
          > i {
            font-size: 11px;
          }
        }
      }
      .open-card-container {
        padding: 5px 0 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        transform: translate3d(0, 0, 0);
        .waiting-card {
          flex: 1;
          width: 0;
          position: relative;
          transform: translate3d(0, 0, 0) rotateY(0);
          transform-style: preserve-3d;
          transition: transform 0.3s ease-in-out;
          z-index: 0;
          &.flipped {
            transform: translate3d(0, 0, 0) rotateY(180deg);
          }
          &:not(:last-child) {
            margin-right: 9px;
          }
          .card-back,
          .card-front {
            transform-style: preserve-3d;
            transform: translate3d(0, 0, 0);
            .content-img {
              width: 100%;
            }
            .decorator-img {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
            }
          }
          .card-back {
            position: relative;
            width: 100%;
            z-index: 2;
            backface-visibility: hidden;
          }
          .card-front {
            width: 100%;
            position: absolute;
            // backface-visibility: hidden;
            transform: translate3d(0, 0, 0) rotateY(180deg);
            top: 0;
            left: 0;
            z-index: 1;
          }
        }
      }
    }
    .divi-line {
      height: 1px;
      width: calc(100% - 4px);
      background: #fff2e7;
      transform: scaleY(0.5);
    }
    .share-card-area {
      margin: 8px 0 13px;
      width: 100%;
      .collect-card-count {
        width: 100%;
        color: #d0001b;
        font-family: 'PingFang SC';
        font-size: 12px;
        font-weight: 500;
        line-height: 17px;
        padding-left: 2px;
      }
      .share-card-container {
        margin-top: 6px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        .card-collection-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          flex: 1;
          position: relative;
          &:not(:last-child) {
            margin-right: 9px;
          }
          .card-img-wrapper {
            width: 100%;
            position: relative;
            .collected,
            .uncollected {
              width: 100%;
            }
            .card-count {
              position: absolute;
              top: -4px;
              right: -4px;
              width: 14px;
              height: 14px;
              background: #ff4718;
              border: 2px solid #ffffff;
              box-sizing: content-box;
              border-radius: 50%;
              color: #ffeddc;
              .count-value {
                position: absolute;
                top: 50%;
                left: 50%;
                text-align: center;
                font-family: PingFang SC;
                font-size: 10px;
                font-weight: 700;
                transform: translate(-50%, -50%) scale(0.9);
                transform-origin: center;
              }
            }
          }
          .gift-btn {
            margin-top: 4px;
            background: linear-gradient(45deg, #ff8948 0%, #ff4c1c 100%),
              #808080;
            padding: 2px 10px;
            border-radius: 10px;
            color: #fff;
            font-family: 'PingFang SC';
            font-size: 11px;
            line-height: 15px;
          }
        }
      }
    }
    .btn-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      .btn-normal {
        padding: 4px 8px;
        border-radius: 20px;
        background: linear-gradient(263.62deg, #ffd99e 4.77%, #ffebd0 92.7%);
        color: #d0001b;
        font-size: 12px;
        line-height: 17px;
      }
      .combine-btn {
        position: relative;
        width: 163px;
        height: 41px;
        background: center / 100% 100%
          url(https://imgheybox.max-c.com/oa/2025/01/20/8ed916b76b5dc3b6bba85c19f1dd7787.png)
          no-repeat;
        &.disabled {
          background-image: url(https://imgheybox.max-c.com/oa/2025/01/22/3125b3ee07806bf5f3d12e8fdc8a6c19.png);
        }
        .open-count-tag {
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          right: 0px;
          top: -8px;
          width: 20px;
          height: 20px;
          background: #ff4718;
          border-radius: 50%;
          border: 2px solid #fff;
          color: #ffeddc;
          font-size: 12px;
          line-height: 20px;
          text-align: center;
        }
      }
    }
  }
}
.gift-modal-wrapper {
  z-index: 100;
  .gift-modal {
    width: 100%;
    // background: #fff;
    // border-radius: 12px;
    // padding: 28px 20px 20px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .gift-title {
      color: #14191e;
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 18px;
      font-weight: 500;
      line-height: 26px;
      max-width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .gift-card-img {
      margin-top: 8px;
      width: 58px;
      height: 58px;
    }
    .gift-tips {
      margin-top: 8px;
      color: #8c9196;
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 13px;
      font-weight: 400;
      line-height: 18px;
    }
    .gift-btn-wrapper {
      height: 42px;
      width: 100%;
      margin-top: 8px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .cancel-btn,
      .gift-btn {
        flex: 1;
        height: 42px;
        border-radius: 5px;
        text-align: center;

        font-family: 'PingFang SC';
        font-size: 14px;
        font-weight: 500;
        line-height: 42px;
      }
      .gift-btn {
        margin-left: 10px;
      }
      .cancel-btn {
        background: rgba(20, 25, 30, 0.1);
        color: #14191e;
      }
      .gift-btn {
        background: linear-gradient(46deg, #ff8747 -0.9%, #ff5220 100.9%);
        color: #fff;
      }
    }
  }
}

.combine-card-modal {
  .modal-wrapper {
    background: transparent;
    width: auto;
    height: auto;
    border-radius: 0;
    max-height: unset;
    .modal-content {
      margin-top: 0;
      max-height: unset;
      padding: 0;
      .lottie-combine-card {
        width: 100%;
        max-width: 480px;
        z-index: 100;
      }
    }
  }
}
.search-user-modal {
  .fade-modal-box {
    background: #fff1e1;
    border-radius: 12px 12px 0 0;
    .title-box {
      display: none;
    }
    .scroll-wrapper {
      width: 100%;
      height: 100%;
      padding: 0 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-bottom: 40px;
      .search-input-wrapper {
        flex-shrink: 0;
        width: 100%;
        height: 30px;
        padding: 0 8px;
        border-radius: 4px;
        border: 0.5px solid #f1cfa9;
        background: #ffe6c9;
        display: flex;
        flex-direction: row;
        align-items: center;
        .search-icon {
          width: 16px;
          height: 16px;
          flex-shrink: 0;
          margin-right: 8px;
        }
        input {
          flex: 1;
          color: #7d4300;
          font-weight: 400;
          font-size: 11px;
          border: none;
          background: transparent;
          height: 20px;
          line-height: 20px;
          &::placeholder {
            color: #ffc079;
          }
        }
      }
      .user-list-container {
        flex: 1;
        width: 100%;
        height: 0;
        overflow-y: scroll;
        margin-top: 8px;
        &::-webkit-scrollbar {
          display: none;
        }
        .user-line {
          width: 100%;
          height: 72px;
          display: flex;
          flex-direction: row;
          align-items: center;
          position: relative;
          &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            height: 1px;
            width: 100%;
            background: #f3f4f5;
            transform: scaleY(0.5);
          }
          .user-avatar {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            flex-shrink: 0;
          }
          .user-info {
            flex: 1;
            width: 0;
            margin-left: 8px;
            .user-name {
              color: #14191e;
              text-align: center;
              font-family: 'PingFang SC';
              font-size: 14px;
              font-weight: 500;
              line-height: 20px;
              text-align: left;
            }
          }
          .user-btn {
            flex-shrink: 0;
            width: 68px;
            height: 30px;
            line-height: 30px;
            color: #fff;
            background: #ed234c;
            font-family: 'PingFang SC';
            font-size: 12px;
            font-weight: 400;
            text-align: center;
            border-radius: 3px;
            &.disabled {
              background: #ffe0bd;
              color: #ffa742;
            }
          }
        }
        .hb-empty {
          height: 145px !important;
        }
      }
    }
  }
}
.lottery-card-modal {
  .modal-wrapper {
    background: transparent;
  }
  .lottery-card-modal-content {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .lottery-card {
      width: 160px;
      position: relative;
      transform: translate3d(0, 0, 0) scale(1) rotateY(360deg);
      transform-style: preserve-3d;
      .card-back {
        width: 100%;
        z-index: 99;
        transform: translateZ(-1px);
      }
      .card-face {
        width: 100%;
        z-index: 100;
        position: absolute;
        top: 0;
        left: 0;
        backface-visibility: hidden;
      }
    }
  }
}

//进入动画
.card-fade-enter {
  opacity: 0.7;
  transform: scale(0.1) !important;
  img {
    transform: rotateY(90deg) !important;
  }
}
.card-fade-enter-active {
  transition: all 0.35s linear;
  img {
    transition: all 0.35s linear;
  }
}
.card-fade-enter-to {
  opacity: 1;
  transform: scale(1) !important;
  img {
    transform: rotateY(360deg) !important;
  }
}

//退出动画
.card-fade-leave-active {
  // transition: all 0.6s linear;
  transform-origin: center;
  animation: quitAnimate 0.6s ease-in-out;
}

@keyframes quitAnimate {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.3);
  }
  100% {
    transform: translate(var(--target-x), var(--target-y))
      scale(var(--target-scale));
  }
}

@rarity_1: #f34f34;
@rarity_2: #fe7f00;
@rarity_3: #7a60ff;
@rarity_4: #00b1fb;
@rarity_5: #de022c;

.lottery-records-modal {
  .modal-wrapper {
    .modal-content {
      padding: 0 14px;
    }
  }
  .message-content {
    width: 100%;
    .records {
      box-sizing: border-box;
      margin: 25px 0 30px;
      max-height: 188px;
      min-height: 148px;
      overflow-y: scroll;
      // padding: 0 20px;
      width: 100%;
      .no-records {
        color: #ffffff;
        font-size: 12px;
        height: 26px;
        line-height: 26px;
        text-align: center;
      }
      .record-item {
        align-items: center;
        display: flex;
        height: 24px;
        justify-content: space-between;
        margin-top: 15px;
        &:first-of-type {
          margin-top: 0;
        }
        .box-img {
          width: 24px;
          height: 24px;
          object-fit: cover;
          margin-right: 2px;
        }
        .prize-name {
          display: flex;
          flex: 1;
          height: 24px;
          overflow: hidden;
          width: 0;
          .inner {
            align-items: center;
            border-radius: 3px;
            box-sizing: border-box;
            display: flex;
            height: 24px;
            max-width: 100%;
            padding-right: 6px;
          }
          .inner.color-1 {
            background-color: rgba(222, 2, 44, 0.1);
            border: 1px solid @rarity_1;
            .tag {
              background-color: @rarity_1;
            }
          }
          .inner.color-2 {
            background-color: rgba(254, 127, 0, 0.1);
            border: 1px solid @rarity_2;
            .tag {
              background-color: @rarity_2;
            }
          }
          .inner.color-3 {
            background-color: rgba(122, 96, 255, 0.1);
            border: 1px solid @rarity_3;
            .tag {
              background-color: @rarity_3;
            }
          }
          .inner.color-4 {
            background-color: rgba(0, 177, 251, 0.1);
            border: 1px solid @rarity_4;
            .tag {
              background-color: @rarity_4;
            }
          }
          .inner.color-5 {
            background-color: rgba(222, 2, 44, 0.1);
            border: 1px solid @rarity_5;
            .tag {
              background-color: @rarity_5;
            }
          }
          .tag {
            align-items: center;
            color: #ffffff;
            display: flex;
            font-size: 12px;
            height: 100%;
            justify-content: center;
            margin-right: 6px;
            width: 43px;
          }
          .text-4 {
            color: #2d2d2d;
            flex: 1;
            font-size: 12px;
            height: 12px;
            height: 100%;
            line-height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        p {
          display: inline-block;
        }
        p.text-1 {
          color: #de022c;
          font-size: 12px;
          height: 19px;
          line-height: 19px;
          text-align: right;
          white-space: nowrap;
          width: 60px;
        }
        p.text-2 {
          color: #de022c;
          font-size: 12px;
          height: 19px;
          line-height: 19px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          white-space: nowrap;
          margin-right: 11px;
        }
      }
    }
  }
  .message-footer {
    overflow: hidden;
    position: relative;
    width: 100%;
    padding: 0 10px;
    p {
      color: #ed234c;
      font-size: 11px;
      line-height: 15px;
      text-align: center;
      width: 100%;
    }
  }
  .hb-empty {
    height: 145px !important;
  }
}
.lottery-prize-pool-modal {
  .fade-modal-box {
    border-radius: 12px 12px 0 0;
    background: linear-gradient(
      146.79deg,
      #ffe8d9 -4.05%,
      #feddc1 19.89%,
      #fff7e7 53.01%,
      #ffcea8 97.84%
    );
    .title-box {
      .title {
        text-align: center;
      }
    }
  }
  .prize-list-cate-wrapper {
    width: 100%;
    height: 100%;
    padding: 0 8px 0 14px;
    -webkit-overflow-scrolling: touch;
    .prize-list-cate-item {
      background-color: transparent;
      border: none;
      &.color-1 {
        .prize-card::after {
          border: 1px solid rgb(235, 63, 39);
        }
        .tag {
          background: linear-gradient(
            90deg,
            #eb3f27 0%,
            rgba(235, 63, 39, 0) 100%
          );
        }
        .prize-cover {
          background: rgba(235, 63, 39, 0.4);
        }
      }
      &.color-2 {
        .prize-card::after {
          border: 1px solid rgb(252, 174, 31);
        }
        .tag {
          background: linear-gradient(
            90deg,
            #fcae1f 0%,
            rgba(252, 174, 31, 0) 100%
          );
        }
        .prize-cover {
          background: rgba(253, 160, 20, 0.4);
        }
      }
      &.color-3 {
        .prize-card::after {
          border: 1px solid rgb(122, 96, 255);
        }
        .tag {
          background: linear-gradient(
            90deg,
            #7a60ff 0%,
            rgba(122, 96, 255, 0) 100%
          );
        }
        .prize-cover {
          background: rgba(122, 96, 255, 0.4);
        }
      }
      &.color-4 {
        .prize-card::after {
          border: 1px solid rgb(0, 177, 251);
        }
        .tag {
          background: linear-gradient(
            90deg,
            #00b1fb 0%,
            rgba(0, 177, 251, 0) 100%
          );
        }
        .prize-cover {
          background: rgba(0, 177, 251, 0.4);
        }
      }
      &.color-5 {
        .prize-card::after {
          border: 1px solid rgb(222, 2, 44);
        }
        .tag {
          background: linear-gradient(
            90deg,
            rgb(222, 2, 44) 0%,
            rgba(46, 173, 87, 0) 100%
          );
        }
        .prize-cover {
          background: rgba(222, 2, 44, 0.4);
        }
      }
      .tag {
        display: block;
        padding: 2px 0 2px 6px;
        color: #ffffff;
        font-weight: 500;
        font-size: 12px;
      }
      .prize-list {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        margin-top: 6px;
        margin-bottom: 14px;
        overflow: hidden;
        .prize-item {
          width: calc(33.333333% - 6px);
          margin: 0 6px 10px 0;
          .prize-name {
            margin-top: 3px;
            line-height: 17px;
            font-size: 12px;
            // color: #D0D2D4;
          }
          .prize-card {
            position: relative;
            width: 100%;
            height: 80px;
            background: rgba(#14191e, 0.8);
            border-radius: 5px;
            &::after {
              content: '';
              position: absolute;
              left: 0;
              top: 0;
              width: 200%;
              height: 200%;
              transform: scale(0.5);
              transform-origin: 0 0;
              box-sizing: border-box;
              border-radius: 10px;
            }
            .prize-cover {
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 24px;
              border-radius: 0 0 5px 5px;
            }
            .prize-image {
              width: 100%;
              height: 56px;
              overflow: hidden;
              border-top-left-radius: 5px;
              border-top-right-radius: 5px;
              img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
            .prize-price {
              height: 24px;
              position: relative;
              color: #ffffff;
              display: flex;
              justify-content: space-between;
              align-items: center;
              border-radius: 0 0 5px 5px;
              padding: 0 10px;
              width: calc((((100vw - 28px) / 3) - 6px) * 2);
              max-width: 290px;
              transform-origin: left;
              transform: scale(0.5);
              .left {
                height: 48px;
                font-size: 18px;
                display: flex;
                align-items: center;
                .text1 {
                  margin-right: 8px;
                }
                .char {
                  margin-right: 2px;
                }
                span {
                  display: inline-block;
                  vertical-align: top;
                  white-space: nowrap;
                  &.large {
                    position: relative;
                    font-size: 22px;
                    font-weight: 500;
                  }
                }
              }
              .split-line {
                flex: 1;
                width: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                .inner {
                  width: 1px;
                  height: 20px;
                  background: rgba(255, 255, 255, 0.2);
                }
              }
              .right {
                height: 48px;
                font-size: 18px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                position: relative;
                .inner-text {
                  font-weight: 400;
                  font-size: 18px;
                  line-height: 26px;
                  color: #ffffff;
                  white-space: nowrap;
                }
              }
            }
          }
        }
      }
    }
  }
}
.wish-prize-modal {
  .modal-wrapper {
    background: transparent;
    max-height: unset;
    .modal-content {
      max-height: unset;
    }
  }
  .wish-card-wrapper {
    position: relative;
    width: 273px;
    height: 406px;
    background: center / 100% 100%
      url(https://imgheybox.max-c.com/oa/2025/01/22/9de92a9a682b0fb13539c08b96e391f6.png)
      no-repeat;
    .wish-card__game-img {
      position: absolute;
      left: 50%;
      top: 67px;
      border: 4px solid #fcbe6b;
      border-radius: 10px;
      width: 241px;
      height: 223px;
      transform: translateX(-50%);
      z-index: 1;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .wish-card__mask {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 273px;
      height: 406px;
      background: center / 100% 100%
        url(https://imgheybox.max-c.com/oa/2025/01/22/e88c41776f8783dd677939613817c388.png)
        no-repeat;
      z-index: 2;
      .wish-card__user-info {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 50%;
        bottom: 103px;
        width: 100%;
        transform: translateX(-50%);
        .avatar {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          border: 1px solid #ffc577;
          overflow: hidden;
          flex-shrink: 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .username {
          color: #ffe8c8;
          font-size: 16px;
          font-weight: 600;
          line-height: 16px;
          margin-left: 4px;
        }
      }
    }
  }
}
.lottery-prize-modal {
  .prize-modal-wrapper {
    width: 100%;
    .no-price {
      width: 169px;
      height: 112px;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .split-line {
      margin-top: 12px;
    }
    .prize-lottery-item {
      background-color: #000000;
      border-radius: 4px;
      box-sizing: border-box;
      // float: left;
      height: 100%;
      margin: 0 auto;
      overflow: hidden;
      padding: 6px;
      position: relative;
      width: 169px;
      &.color-1 {
        background-color: @rarity_1;
        border: 1px solid @rarity_1;
        color: #bb2d16;
        .tag {
          background-color: @rarity_1;
        }
      }
      &.color-2 {
        background-color: @rarity_2;
        border: 1px solid @rarity_2;
        color: @rarity_2;
        .tag {
          background-color: @rarity_2;
        }
      }
      &.color-3 {
        background-color: @rarity_3;
        border: 1px solid @rarity_3;
        color: #a889ff;
        .tag {
          background-color: @rarity_3;
        }
      }
      &.color-4 {
        background-color: @rarity_4;
        border: 1px solid @rarity_4;
        color: #186687;
        .tag {
          background-color: @rarity_4;
        }
      }
      &.color-5 {
        background-color: @rarity_5;
        border: 1px solid @rarity_5;
        color: @rarity_5;
        .tag {
          background-color: @rarity_5;
        }
      }
      .prize-name {
        align-items: center;
        display: flex;
        height: 16px;
        justify-content: center;
        width: 100%;
        p {
          color: #ffffff;
          font-size: 11px;
          height: 11px;
          line-height: 11px;
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .image-box {
        border-radius: 4px;
        margin-top: 4px;
        position: relative;
        width: 100%;
        img {
          height: 77px;
          object-fit: cover;
          width: 100%;
        }
        .image-cover {
          border-radius: 0px 0px 2px 2px;
          bottom: 0;
          height: 35px;
          left: 0;
          position: absolute;
          width: 100%;
          &.color-1 {
            background: linear-gradient(
              360deg,
              rgba(235, 63, 39, 0.4) 0%,
              rgba(235, 63, 39, 0) 100%
            );
          }
          &.color-2 {
            background: linear-gradient(
              360deg,
              rgba(253, 160, 20, 0.4) 0%,
              rgba(253, 160, 20, 0) 100%
            );
          }
          &.color-3 {
            background: linear-gradient(
              360deg,
              rgba(122, 96, 255, 0.4) 0%,
              rgba(122, 96, 255, 0) 100%
            );
          }
          &.color-4 {
            background: linear-gradient(
              360deg,
              rgba(0, 177, 251, 0.4) 0%,
              rgba(0, 177, 251, 0) 100%
            );
          }
          &.color-5 {
            background: linear-gradient(
              360deg,
              rgba(46, 173, 87, 0.4) 0%,
              rgba(46, 173, 87, 0) 100%
            );
          }
        }
      }
      .tag {
        align-items: center;
        border-radius: 2px;
        bottom: -3px;
        color: #ffffff;
        display: flex;
        font-size: 16px;
        height: 30px;
        justify-content: center;
        line-height: 22px;
        position: absolute;
        right: -12px;
        text-align: center;
        transform-origin: left top;
        transform: scale(0.5);
        width: 48px;
        z-index: 1;
      }
    }
    .distribute-desc {
      line-height: 16px;
      font-size: 11px;
      margin: 14px 0 0;
      text-align: center;
    }
    .btn-done {
      width: 100%;
      height: 36px;
      line-height: 36px;
      color: #ffffff;
      margin-top: 16px;
      font-size: 16px;
      text-align: center;
      border-radius: 5px;
      background: #ed234c;
    }
  }
}
</style>
